module.exports = __webpack_public_path__ + "static/media/Laugo_02.ba498acc.jpg";